import { gql } from 'graphql-request';
import { graphqlClient } from '../client';

// The GraphQL mutation for adding a charge
const ADD_CHARGE_MUTATION = gql`
  mutation AddCharge($input: ChargeInput!) {
    addCharge(input: $input) {
      id
      type
      currency
      price
      notes
      price_per
      included_quantity
      overage_price
      overage_quantity
      minimum_price
      pricing_metric {
        id
        display_name
        modality
      }
    }
  }
`;

// Response type definition
export interface AddChargeResponse {
  addCharge: {
    id: string;
    type: string;
    currency: string | null;
    price: string | null;
    notes: string | null;
    price_per: string | null;
    included_quantity: number | null;
    overage_price: string | null;
    overage_quantity: number | null;
    minimum_price: string | null;
    pricing_metric: {
      id: string;
      display_name: string | null;
      modality: string | null;
    } | null;
  };
}

// Input type definition
export interface ChargeInput {
  price?: number | null;
  currency?: string | null;
  price_per?: string | null;
  type: string;
  pricing_metric_id?: string | null;
  plan_id: string;
  notes?: string | null;
  included_quantity?: number | null;
  overage_price?: string | null;
  overage_quantity?: number | null;
  minimum_price?: string | null;
  versions: string[];
  page_id: string;
}

/**
 * GraphQL mutation to add a new charge
 * 
 * @param input The charge data to add
 * @returns Response containing the new charge data
 */
export async function addChargeMutation(
  input: ChargeInput
): Promise<AddChargeResponse> {
  try {
    console.log(`🔄 [GraphQL] Adding new charge for plan ${input.plan_id}`, input);
    
    // Execute the GraphQL mutation
    const response = await graphqlClient.request<AddChargeResponse>(
      ADD_CHARGE_MUTATION,
      { input }
    );
    
    console.log('✅ [GraphQL] Charge creation response:', response);
    
    return response;
  } catch (error) {
    console.error('❌ [GraphQL] Error creating charge:', error);
    throw error;
  }
}
